// extracted by mini-css-extract-plugin
export default {"sticky":"LiabilitiesAndEquityBody_sticky__qX9O9","stickyTop":"LiabilitiesAndEquityBody_stickyTop__V3ri2"};